import React from "react";
import { styled } from "@mui/material/styles";
import { tokens as t } from "./tokens";

// Variant-ууд: brand (үндсэн), ghost (хүрээтэй цагаан), soft, danger
const variants = {
  brand: {
    background: t.color.brand,
    color: "#fff",
    border: "1px solid transparent",
    "&:hover": { background: t.color.brandDark, boxShadow: t.shadow.md },
  },
  ghost: {
    background: "#fff",
    color: t.color.text,
    border: `1px solid ${t.color.line}`,
    "&:hover": { borderColor: t.color.brand, color: t.color.brandDark },
  },
  soft: {
    background: t.color.brandSoft,
    color: t.color.brandDark,
    border: "1px solid transparent",
    "&:hover": { background: "#d6ebe8" },
  },
  danger: {
    background: "#fff",
    color: t.color.red,
    border: `1px solid ${t.color.line}`,
    "&:hover": { background: t.color.redSoft, borderColor: t.color.red },
  },
};

const Root = styled("button", {
  shouldForwardProp: (p) => !["variant", "size", "block"].includes(p),
})(({ variant = "brand", size = "md", block }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  height: size === "sm" ? 34 : size === "lg" ? 48 : 40,
  padding: size === "sm" ? "0 12px" : "0 16px",
  borderRadius: t.radius.md,
  fontFamily: t.font.body,
  fontWeight: 600,
  fontSize: size === "lg" ? 14 : 13,
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all .14s ease",
  width: block ? "100%" : "auto",
  "&:hover": { transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&:disabled": { opacity: 0.55, cursor: "default", transform: "none" },
  "& svg": { width: 17, height: 17 },
  ...variants[variant],
}));

const Button = ({ children, icon: Icon, ...rest }) => (
  <Root {...rest}>
    {Icon ? <Icon /> : null}
    {children}
  </Root>
);

export default Button;
